import * as React from 'react';

import { ChatPlugin } from '@common/react/components/Chat/Chat';
import LinkPreviewGroup from '@common/react/components/UI/LinkPreview/LinkPreviewGroup';

export const LinkPreviewPlugin: ChatPlugin = {
	listComponent: ({ links, linkPreviewId }) => <LinkPreviewGroup links={links} linkPreviewId={linkPreviewId} />,
};
